module.exports = __webpack_public_path__ + "static/media/slide_three.9aa09a50.jpg";